export const DEFAULT_PAGE = 0;
export const DEFAULT_SIZE = 10;
export const DEFAULT_SIZE_100 = 100;

export enum PaginationConstants {
  DESCENDING = 'DESC',
  ASCENDING = 'ASC',
}
